export default "/images/framework/CloseNoShadow.52201f0e.svg?52201f0e";